<div class="menu-content">
    <div class="menu-content-header">
        <div class="app-favicon" aria-hidden="true" [class.hidden]="!collapsed()">
            <img src="/images/favicon.png" />
        </div>
        <div class="app-logo" aria-hidden="true" [class.hidden]="collapsed()">
            <img src="https://assets.veneciait.com/images/apps/logo-vic-v0.png" />
        </div>  
        <button type="button" class="btn btn-light border ms-3" [class.d-none]="!offset()" aria-label="Close offset"
            (click)="closeOffset()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>

    <nav class="menu-content-nav flex-column gap-1">
        @for (item of menuItems; track item.item) {
        <a class="nav-link" [routerLink]="item.route" routerLinkActive="active"
            [attr.title]="collapsed() ? item.label : null">
            <i [class]="item.iconClass"></i>
            <span class="nav-label" [class.is-collapsed]="collapsed()">{{ item.label| translate }}</span>
        </a>
        }
    </nav>
</div>